const IP_REGEXP = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const isIP = address => IP_REGEXP.test(address);
const getDomain = hostname => isIP(hostname) ? hostname : hostname.split('.').reverse().splice(0, 2).reverse().join('.');
export const getRootDomain = () => getDomain(global.document.location.hostname);
export default getDomain;